import { v4 as uuidv4 } from "uuid";

// v4 is random, v5 is deterministic
export const generateUuid = () => uuidv4();
